<template>
    <div>
        <p class="title-page">Mensagens LUA</p>
        <Mensagem />
    </div>
</template>

<script>
import Mensagem from "../components/Mensagem.vue";
export default {
    name: "MensagensLua",

    components: {
        Mensagem,
    },
    data: () => ({

    }),
    methods: {
        
    },
}
</script>